export function formatNumber(value: number): string {
  if (isNaN(value)) return '0';
  return value.toLocaleString('en-NG');
}
